import { initialIsWorking } from './initialState'

export default (state, { type, payload = {}, meta = {} }) => {
    switch (type) {
        case 'UPLOAD_FILE##REQUEST': {
            const { contentType } = meta

            return {
                ...state,
                isWorking: contentType
                    ? {
                          ...state.isWorking,
                          [contentType]: true,
                      }
                    : {
                          ...initialIsWorking,
                      },
                uploaded: [],
            }
        }
        case 'UPLOAD_FILE##FAILURE':
        case 'UPLOAD_FILE##SUCCESS': {
            const { contentType } = meta

            return {
                ...state,
                isWorking: contentType
                    ? {
                          ...state.isWorking,
                          [contentType]: false,
                      }
                    : {
                          ...initialIsWorking,
                      },
                uploaded: [],
            }
        }
        case 'UPLOAD_FILE#UPLOADED':
            return {
                ...state,
                uploaded: [...state.uploaded, ...payload],
            }
        default:
            return null
    }
}
